<template>
  <v-card class="mt-3" shaped="shaped">
    <v-card-title class="">
      <p class="mt-0 mb-0 fontQuestion">
        {{ questionData.questionText }}
      </p>
    </v-card-title>
    <v-card-text>
      <v-divider class="mt-2 mb-3"></v-divider>
      <v-radio-group
        v-model="currentAnswer"
        class="txtQuestion"
        @change="onChange"
      >
        <v-row>
          <v-col cols="12">
            <v-radio
              v-for="(item, index) in questionData.choices"
              :key="item.choiceText"
              :value="index"
              color="indigo darken-4"
            >
              <template v-slot:label>
                <span v-if="!showColor || index !== currentAnswer">{{
                  item.choiceText
                }}</span>
                <span
                  class="correct"
                  v-else-if="showColor && index === questionData.answerIndex"
                  >{{ item.choiceText }}</span
                >
                <span class="incorrect" v-else>{{ item.choiceText }}</span>
              </template>
            </v-radio>
          </v-col>
        </v-row>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>


<script>
/*
  QuestionData
  {
    questionText: String,
    choices: [
      {
        choiceText: String,
      }
    ],
    answerIndex: Number,
  }
*/
export default {
  props: {
    questionData: Object,
    attemptNumber: Number,
  },
  data() {
    return {
      currentAnswer: null,
      showColor: false,
    };
  },
  methods: {
    onChange(val, oldVal) {
      this.showColor = false;
      if (this.currentAnswer == this.questionData.answerIndex) {
        this.questionData.score = 1;
      } else {
        this.questionData.score = 0;
      }
    },
    checkAnswer() {
      this.showColor = true;
    },
  },
  watch: {
    attemptNumber() {
      this.checkAnswer();
    },
  },
};
</script>

<style scoped>
  .correct {
    color: green;
  }
  .incorrect {
    color: red;
  }
  .txtCorrect {
    color: red;
  }
  label {
    font-size: 18px;
  }
  .txtQuestion /deep/ label {
    font-size: 16px;
  }
  .fontQuestion {
    font-size: 18px;
  }
</style>